import _ from "lodash";
import { twMerge } from "tailwind-merge";
import { motion } from "framer-motion";

import { LinkSubmenuItem } from "./link-submenu-item";
import { useLinkContext } from "./link-context";
import { useMenu } from "../../../store/global/useMenu";
import { AnimatePresence } from "framer-motion";
import { getCurrentDepartment } from "../../../services/functions";

export function LinkSubmenu({ className, list }) {
  const ctx = useLinkContext()
  const item = useMenu(st => st.data.itens[ctx.name])

  return (
    <motion.div
      variants={{
        open: {
          height: "auto",
          opacity: 1,
          paddingTop: "0.375rem",
          paddingBottom: "0.375rem",
        },
        closed: {
          height: 0,
          opacity: 0,
          paddingTop: "0rem",
          paddingBottom: "0rem",
        },
      }}
      initial={item?.open ? "open" : "closed"}
      animate={item?.open ? "open" : "closed"}
      transition={{ duration: 0.3 }}
      className={twMerge(
        "flex w-full flex-col overflow-hidden shadow-inner py-1.5 bg-zinc-100 group-hover:!bg-scale-50 mb-2",
        "group-data-[menu-open=false]:transition group-data-[menu-open=false]:duration-300",
        item?.open && "group-data-[menu-open=false]:!h-auto group-data-[menu-open=false]:!opacity-100 group-data-[menu-open=false]:!py-1.5 group-data-[menu-open=false]:abasolute group-data-[menu-open=false]:left-full group-data-[menu-open=false]:top-0 group-data-[menu-open=false]:z-20 group-data-[menu-open=false]:w-48 group-data-[menu-open=false]:shadow-lg group-data-[menu-open=false]:rounded-br-md",
        className
      )}
    >
      <AnimatePresence initial={false} mode="sync">
        {list.map(
          (subitem) =>
            !_.castArray(subitem.hidden).includes(getCurrentDepartment()) && (
              <LinkSubmenuItem key={subitem.to} {...subitem}>
                {subitem.label}
              </LinkSubmenuItem>
            )
        )}
      </AnimatePresence>
    </motion.div>
  );
}
